import type { LocationData } from "../../../mocks/locationData";

interface LocationServicesProps {
  location: LocationData;
  onBookNow: () => void;
}

export default function LocationServices({ location, onBookNow }: LocationServicesProps) {
  return (
    <section className="bg-cl-tint py-20 px-6 lg:px-10">
      <div className="max-w-screen-xl mx-auto">
        <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between mb-12 gap-4">
          <div>
            <p className="text-xs font-black text-cl-green uppercase tracking-widest mb-2">Available in {location.city}</p>
            <h2 className="text-3xl md:text-4xl font-black text-cl-dark leading-tight">
              Services We Offer in <span className="text-cl-green">{location.city}</span>
            </h2>
            <p className="text-gray-500 font-semibold mt-2">Fully licensed collection teams — fixed price, no hidden charges</p>
          </div>
          <button
            onClick={onBookNow}
            className="bg-cl-green text-white font-black px-6 py-3 rounded-xl text-sm cartoon-btn-green whitespace-nowrap flex-shrink-0"
          >
            Book Online Now
          </button>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {location.services.map((service) => (
            <a
              key={service.label}
              href={service.href}
              className="group bg-white rounded-2xl p-6 thick-border cartoon-shadow hover:-translate-y-1 transition-all duration-200 cursor-pointer flex items-center gap-4"
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-cl-lime border-2 border-cl-green flex-shrink-0 group-hover:bg-cl-green transition-colors">
                <i className={`${service.icon} text-xl text-cl-dark group-hover:text-white transition-colors`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-cl-dark font-black text-base group-hover:text-cl-green transition-colors">{service.label}</p>
                <p className="text-gray-500 text-sm font-semibold">{service.price}</p>
              </div>
              <i className="ri-arrow-right-line text-gray-300 group-hover:text-cl-green transition-colors flex-shrink-0"></i>
            </a>
          ))}
        </div>

        {/* Areas served */}
        <div className="mt-10 bg-white rounded-2xl p-6 thick-border cartoon-shadow">
          <p className="text-xs font-black text-cl-green uppercase tracking-widest mb-4">Areas We Serve</p>
          <div className="flex flex-wrap gap-2">
            {location.areasServed.map((area) => (
              <span
                key={area}
                className="bg-cl-lime text-cl-dark text-xs font-black px-3 py-1.5 rounded-full border border-cl-green"
              >
                {area}
              </span>
            ))}
          </div>
          <p className="text-gray-500 text-sm font-semibold mt-4">
            Not sure if we cover your area? <a href="tel:03335775445" className="text-cl-green font-black hover:underline cursor-pointer">Call us — 03335 775445</a>
          </p>
        </div>
      </div>
    </section>
  );
}
